import { STORAGE_KEYS } from '@/lib/api/endpoints';
import { decodeJwtPayload, getTenantIdFromToken } from '@/lib/auth/token-utils';

function getStoredToken(): string | null {
  return localStorage.getItem(STORAGE_KEYS.tenantToken);
}

/** Resolve tenant id for queries — works when OAuth stored token+id but slug not yet hydrated. */
export function resolveTenantId(): string {
  const token = getStoredToken();
  const stored = localStorage.getItem(STORAGE_KEYS.tenantId);
  if (stored && token && getTenantIdFromToken(token) === stored) return stored;
  if (token) {
    const fromJwt = getTenantIdFromToken(token);
    if (fromJwt) return fromJwt;
  }
  return stored ?? '';
}

export function hydrateTenantSlugFromToken(): void {
  const token = getStoredToken();
  if (!token) return;
  const jwt = decodeJwtPayload(token);
  if (jwt?.tenant_slug && !localStorage.getItem(STORAGE_KEYS.tenantSlug)) {
    localStorage.setItem(STORAGE_KEYS.tenantSlug, jwt.tenant_slug);
  }
  if (!localStorage.getItem(STORAGE_KEYS.tenantName)) {
    const name = jwt?.tenant_slug ?? 'Tenant';
    localStorage.setItem(STORAGE_KEYS.tenantName, name);
  }
}
